import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

import {SignatureMethodEnum} from '../../files/files.model';

@Component({
  selector: 'gp-signature-method-select',
  templateUrl: './signature-method-select.component.html',
  styleUrls: ['./signature-method-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignatureMethodSelectComponent {

  @Input()
  public options: SignatureMethodEnum[] = [];

  @Input()
  public selected: SignatureMethodEnum[] = [];

  @Input()
  public compact = false;

  @Input()
  public multiple = false;

  @Input()
  public disabled = false;

  @Output()
  public selectedChange: EventEmitter<SignatureMethodEnum> = new EventEmitter<SignatureMethodEnum>();

  public isSelected(method: SignatureMethodEnum): boolean {
    return (this.selected ?? []).includes(method);
  }

  public isDisabled(method: SignatureMethodEnum): boolean {
    return this.disabled || (this.multiple && this.isSelected(method) && this.selected.length === 1);
  }

  public select(method: SignatureMethodEnum): void {
    this.selectedChange.emit(method);
  }
}
